import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import {
  TsrctInitiationMode,
  TsrctNegotiationMode,
  TsrctQuoteMode,
  TsrctSupplierInteractionMode,
  TsrctNegotiationObjective,
} from '@/generated/gql/graphql';

export const negotiationOptionsLegacySchema = z.object({
  options: z.object({
    initiatedBy: z.enum(TsrctInitiationMode),
    quoteMode: z.enum(TsrctQuoteMode),
    negotiationMode: z.enum(TsrctNegotiationMode),
    supplierInteractionMode: z.enum(TsrctSupplierInteractionMode),
    negotiationObjective: z.enum(TsrctNegotiationObjective),
  }),
});

export type NegotiationOptionsLegacyFormData = z.infer<typeof negotiationOptionsLegacySchema>;

export const negotiationOptionsLegacyFormDataDefault: DefaultValues<NegotiationOptionsLegacyFormData> = {
  options: {
    supplierInteractionMode: TsrctSupplierInteractionMode.COMMENT_ENABLED,
    negotiationMode: TsrctNegotiationMode.SUPPLIER_SELECTION,
    quoteMode: TsrctQuoteMode.BID_SHEET,
    initiatedBy: TsrctInitiationMode.PROCUREAI,
    negotiationObjective: TsrctNegotiationObjective.PRIORITISE_COMMERCIAL_RESULT,
  },
};
